<template>
  <!-- common categories -->
  <div
    v-mask="{ open }"
    class="menu-area__categories__container">

    <div class="menu-area__categories">
      <div class="menu-area__categories__back-mobile" @click="toggleCategories()">Indietro</div>
      <!-- tabs area -->
      <div class="menu-area__categories__tabs menu-area__categories__tabs--menu_tabs">
        <ul>
          <li
            @click="$_activeTab('all')"
            :class="{'menu-area__categories__tabs__li--active': activeTab === 'all'}">
              Tutti i prodotti
          </li>
          <li
            @click="$_activeTab('news')"
            :class="{'menu-area__categories__tabs__li--active': activeTab === 'news'}">
              Prodotti novità
          </li>
        </ul>
      </div>

      <!-- ALL tab -->
      <div
        v-show="activeTab === 'all'"
        class="menu-area__categories__section menu-area__categories__section--all">
        
        <div class="menu-area__categories__contents">
          <ul class="menu-area__categories__all">
            <li
              v-for="(category, index) of categories"
              :key="index">
              <router-link :to="{ name: 'single-category', params: { slug: category.fields.slug } }">
                <img
                  v-if="typeof category.fields.image !== 'undefined'"
                  :src="`${category.fields.image.fields.file.url}?w=150&fit=scale`"
                  :alt="category.fields.image.fields.description"
                  :width="150">
                <div>
                  <p>{{ category.fields.title }} <sup v-html="$_getProductsCount(category.fields.slug)" /></p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <TagsByParentsList />

      </div>

      <!-- NEWS tab -->
      <div
        v-show="activeTab === 'news' && typeof newsList !== 'undefined'"
        class="menu-area__categories__section menu-area__search__content">
        <ProductsFromList :list="newsList" />
      </div>

    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TweenLite } from 'gsap/TweenLite'
import { TweenMax } from 'gsap/TweenMax'

import ProductsFromList from '@/components/ProductsFromList/ProductsFromList.vue'
import TagsByParentsList from '@/components/Menu/TagsByParentsList/TagsByParentsList.vue'

export default {
  name: 'MenuCategories',
  components: {
    ProductsFromList,
    TagsByParentsList
  },
  data: () => ({
    loading: true,
    activeTab: 'all' // news, special
  }),
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'root',
      'tagsParents',
      'tags',
      'products',
      'tag',
      'nodes'
    ]),
    orderedTagsParents: {
      get () {
        if (this.loading) return []
        return this.tagsParents.sort((a, b) => {
          if (a.fields.order < b.fields.order) return -1
          if (a.fields.order > b.fields.order) return 1
          return 0
        })
      }
    },
    newsList: {
      get () {
        if (this.loading) return []
        return this.$_filterEntriesByTagId('1EiZKOpvDNKhXd2z0xHWJd')
      }
    },
    categories: {
      get () {
        if (this.loading) return undefined
        return this.root.fields.nodesList.reduce((accumulator, currentValue) => {
          if (typeof currentValue.fields.category !== 'undefined' && typeof currentValue.fields.category.fields.image !== 'undefined' && typeof currentValue.fields.category.fields.imageSet !== 'undefined'){
            accumulator.push(currentValue.fields.category)
          }
          return accumulator
        }, [])
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadRoot',
      'loadTagsParents',
      'loadTags',
      'loadProducts',
      'loadNodes'
    ]),
    toggleCategories () {
      this.$emit('toggle-categories')
      // this.open = !this.open
    },
    $_getProductsCount (currentSlug) {
      const currentNode = this.nodes.find(node => {
        return node.fields.category.fields.slug === currentSlug
      })
      return this.$_getCategoryProducts([currentNode]).length
    },
    $_getCategoryProducts (nodes) {
      var products = []
      nodes.forEach(node => {
        if (typeof node.fields.products !== 'undefined') products = products.concat(node.fields.products)
        if (typeof node.fields.nodesList !== 'undefined') products = products.concat(this.$_getCategoryProducts(node.fields.nodesList))
      })
      return products
    },
    $_filterEntriesByTagId (tagId) {
      return this.products
        .filter(productElement => typeof productElement.fields.tags !== 'undefined')
        .reduce((accumulator, productElement) => {
          if (productElement.fields.tags === undefined) return accumulator
          productElement.fields.tags.forEach(tag => {
            if (typeof tag.sys.id !== 'undefined' && tag.sys.id === tagId) return accumulator.push(productElement)
          })
          return accumulator
        }, [])
    },
    $_activeTab (state) {
      this.activeTab = state
    },
    $_filterEntriesByTagParentTitle (tagTitle) {
      return this.tags
        .filter(t => typeof t.fields.parentGroup !== 'undefined')
        .filter(t => tagTitle === t.fields.parentGroup.fields.title)
    },
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadRoot(), this.loadTagsParents(), this.loadTags(), this.loadProducts(), this.loadNodes()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  },
  directives: {
    'mask': {
      inserted (el, binding) {
        TweenLite.to(el, 0, {width:'0%'})
      },
      componentUpdated (el, binding) {
        const { open } = binding.value
        if (open) {
          TweenLite.to(el, .8, {ease: Power2.easeOut, width:'100%', onComplete: () => document.body.classList.add('--overflow-hidden')})
        }
        else{
          document.body.classList.remove('--overflow-hidden')
          TweenLite.to(el, .8, {ease: Power2.easeOut, width:'0%'})
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./categories.scss";
  @import "./maskEffect.scss";
</style>
